import { IP_Floor } from './types'
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper'
import { useStyletron } from 'baseui';
import { FormattedMessage, useIntl } from 'react-intl';
import { StyledLink } from 'baseui/link';
import { GetObjectUrl } from '../../../../utils/navigationService';
import { Link } from 'react-router-dom';
import { Banner, KIND } from 'baseui/banner';
import { Icon } from './Icon';
import { RoomsOverviewPanel } from '../../../SubPlants/SP_Room/RoomsOverviewPanel';
import ActiveLightsPanel from '../../../Devices/Light/ActiveLightsPanel';
import OpenWindowPanel from '../../../Devices/WindowContact/OpenWindowPanel';
import { RoomsTemperatures } from '../../../SubPlants/SP_Room';
import { VerticalStackPanel } from '../../../../components/Layout/StackPanel';


export function OverviewPanel(props: IP_Floor) {
    const [css, theme] = useStyletron();

    return (
        <OverviewPanelWrapper  icon={<Icon color={theme.colors.backgroundPrimary}></Icon>} {...props}>
            <VerticalStackPanel $gap={theme.sizing.scale800} $alignItems={'center'}>
                {!props.initialized &&
                    <Banner kind={KIND.warning}>
                        <FormattedMessage id="P_Floor.NotInitializedSmall" defaultMessage="Floor configuration is missing." />
                        <span> </span>
                        <Link to={`${GetObjectUrl(props.resourceGroupId, props.id)}?defaultView=configuration`} className={css({ textDecoration: 'none' })}>
                            <StyledLink animateUnderline ><FormattedMessage id="configuration" defaultMessage="Configuration" /></StyledLink>
                        </Link>
                    </Banner>}
                <RoomsOverviewPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></RoomsOverviewPanel>
                <ActiveLightsPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></ActiveLightsPanel>
                <OpenWindowPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></OpenWindowPanel>
                <RoomsTemperatures parentId={props.id} resourceGroupId={props.resourceGroupId}></RoomsTemperatures>
            </VerticalStackPanel>
        </OverviewPanelWrapper>
    );
}


